import { initializeLocalization } from 'owa-localize';

export var userLocale: string;

export var userSmtpAddress: string;

export var prefetchedStrings: Record<string, string>;

export var needInitialization: boolean;

export function initializeStrings(): void {
    let locale = 'en';

    if (userLocale) {
        locale = userLocale;
    }

    initializeLocalization(locale, prefetchedStrings);
}

export function registerStrings(prefetchedStringsValue: Record<string, string>) {
    prefetchedStrings = prefetchedStringsValue;
}

export function initializeUserSettings(userSmtpAddressValue: string, userLocaleValue: string) {
    userLocale = userLocaleValue;
    userSmtpAddress = userSmtpAddressValue;
}

export function getUserSmtp() {
    return userSmtpAddress;
}
